export type Tema = 'claro' | 'escuro' | 'sistema';
const CHAVE = 'sheafyield:tema';

export function lerTema(): Tema {
  try {
    const v = localStorage.getItem(CHAVE);
    return v === 'claro' || v === 'escuro' ? v : 'sistema';
  } catch {
    return 'sistema';
  }
}

// Mesma regra do script síncrono do index.html: a escolha vence a media query.
export function aplicarTema(
  tema: Tema,
  raiz: HTMLElement = document.documentElement,
): void {
  if (tema === 'sistema') {
    delete raiz.dataset['tema'];
    raiz.style.colorScheme = '';
  } else {
    raiz.dataset['tema'] = tema;
    raiz.style.colorScheme = tema === 'escuro' ? 'dark' : 'light';
  }
}

export function gravarTema(tema: Tema): void {
  try {
    if (tema === 'sistema') localStorage.removeItem(CHAVE);
    else localStorage.setItem(CHAVE, tema);
  } catch {
    // Sem localStorage (modo privado): o tema vale só nesta sessão.
  }
  aplicarTema(tema);
}
